import ItemAnexo from './ItemAnexo'
import enhancer from './ItemAnexo.enhancer'

export default enhancer(ItemAnexo)


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Anexos/components/ItemAnexo/index.js